module.exports = require("run-async");


//////////////////
// WEBPACK FOOTER
// external "run-async"
// module id = 11
// module chunks = 0